import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import HorizontalRule from "@mui/icons-material/HorizontalRule";
import { useCallback } from "react";
import { useDialog } from "../../../../../utils/hooks/use-dialog";
import { isChatChannel } from "../../../../channels/types";
import { AddDividerForm } from "../../components/add-divider-form";
import { INSERT_DIVIDER_COMMAND } from "../../types/commands";
import { ToolbarIconButton } from "./toolbar-icon-button";

import type { ChannelName } from "../../../../channels/types";
import type { ToolbarProps } from "./props";
import type { FC } from "react";

export const AddDivider: FC<
  ToolbarProps & { channel: NonNullable<ChannelName>; label?: string }
> = ({ disabled, label, onClick, channel }) => {
  const dialog = useDialog();
  const [editor] = useLexicalComposerContext();

  const handleChatAdd = useCallback(() => {
    editor.dispatchCommand(INSERT_DIVIDER_COMMAND, undefined);
    onClick?.();
  }, [onClick, editor]);

  const handleEmailAdd = useCallback(
    (data: { type: "primary" | "secondary" }) => {
      if (data) editor.dispatchCommand(INSERT_DIVIDER_COMMAND, data);
      dialog.handleClose();
      onClick?.();
    },
    [onClick, editor, dialog],
  );

  return (
    <>
      <ToolbarIconButton
        data-analytics-id="lexical-toolbar-divider"
        sx={{ width: label && "100%", justifyContent: "start" }}
        disabled={disabled}
        label={label}
        icon={<HorizontalRule fontSize="medium" />}
        data-testid="toolar-button-divider"
        aria-label="Divider"
        tabIndex={-1}
        onClick={isChatChannel(channel) ? handleChatAdd : dialog.handleOpen}
      />
      <AddDividerForm onConfirm={handleEmailAdd} onCancel={dialog.handleClose} open={dialog.open} />
    </>
  );
};
